// SessionContext.jsx
import React, { createContext, useContext, useState } from 'react';

const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  const [isSessionPaused, setIsSessionPaused] = useState(false);

  const pauseSession = () => setIsSessionPaused(true);
  const resumeSession = () => setIsSessionPaused(false);

  return (
    <SessionContext.Provider
      value={{ isSessionPaused, pauseSession, resumeSession }}
    >
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);